import PropTypes from "prop-types";
import {
  BLINK_SHAPES,
  DEFAULT_BLINK_SHAPE,
  DEFAULT_BLINK_SPEED,
  getDefaultHologramState,
  parseBlinkSpeed,
} from "../utils/hologramState";

/**
 * Champs de clignotement d'un hologramme : sélecteur "Clignotement" et, si la forme
 * n'est pas "Off", champ "Vitesse de clignotement".
 * `value` : { blinkShape, blinkSpeed } (blinkSpeed peut être une chaîne en cours de saisie).
 * `onChange` reçoit le nouvel état complet.
 * À afficher uniquement quand un hologramme est présent (fichier choisi ou enregistré).
 */
const HologramBlinkFields = ({
  value,
  onChange,
  shapeTitle = "Type de clignotement des partie emissive de l'hologramme",
  speedTitle = "Vitesse de clignotement (nombre strictement positif)",
}) => {
  const shape = BLINK_SHAPES.includes(value?.blinkShape) ? value.blinkShape : DEFAULT_BLINK_SHAPE;
  const speed = value?.blinkSpeed ?? DEFAULT_BLINK_SPEED;
  const speedNumber = parseBlinkSpeed(speed);
  const speedInvalid = speedNumber === null || speedNumber <= 0;

  const handleShapeChange = (e) => {
    const newShape = e.target.value;
    // Retour sur Off : la vitesse est remise à sa valeur par défaut
    if (newShape === DEFAULT_BLINK_SHAPE) onChange(getDefaultHologramState());
    else onChange({ blinkShape: newShape, blinkSpeed: speed });
  };

  return (
    <div alt="clignotement de l'hologramme" className="mt-2">
      <label className="form-label small mb-0" title={shapeTitle}>Clignotement ℹ️</label>
      <select
        className="form-select form-select-sm"
        value={shape}
        title={shapeTitle}
        onChange={handleShapeChange}
      >
        {BLINK_SHAPES.map((blinkShape) => (
          <option key={blinkShape} value={blinkShape}>{blinkShape}</option>
        ))}
      </select>
      {shape !== DEFAULT_BLINK_SHAPE && (
        <div className="mt-2">
          <label className="form-label small mb-0" title={speedTitle}>Vitesse de clignotement ℹ️</label>
          <input
            type="text"
            inputMode="decimal"
            className={`form-control form-control-sm${speedInvalid ? " is-invalid" : ""}`}
            value={String(speed)}
            title={speedTitle}
            onChange={(e) => onChange({ blinkShape: shape, blinkSpeed: e.target.value })}
          />
        </div>
      )}
    </div>
  );
};

HologramBlinkFields.propTypes = {
  value: PropTypes.shape({
    blinkShape: PropTypes.string,
    blinkSpeed: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  onChange: PropTypes.func.isRequired,
  shapeTitle: PropTypes.string,
  speedTitle: PropTypes.string,
};

export default HologramBlinkFields;
